import React from "react";
import { FadeInView } from "~/native-ui/AnimatedView";
import { DrawerAnimationContext} from "./DrawerAnimationContext";

export const FadeInWithDrawerView = (props) => {
    const animation = React.useContext(DrawerAnimationContext);

    const animatedViewProps = {
        ...props,
        animation,
    }

    return <FadeInView {...animatedViewProps} />
}